import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CropSquareOutlinedIcon from "@mui/icons-material/CropSquareOutlined";
import GestureOutlinedIcon from "@mui/icons-material/GestureOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import MouseOutlinedIcon from "@mui/icons-material/MouseOutlined";
import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import RedoOutlinedIcon from "@mui/icons-material/RedoOutlined";
import TextFieldsOutlinedIcon from "@mui/icons-material/TextFieldsOutlined";
import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import ZoomOutOutlinedIcon from "@mui/icons-material/ZoomOutOutlined";

export const NATIVE_CANVAS_TOOLS = Object.freeze([
  { Icon: PanToolOutlinedIcon, id: "hand", label: "Hand", shortcut: "H" },
  { Icon: MouseOutlinedIcon, id: "select", label: "Select", shortcut: "1" },
  {
    Icon: CropSquareOutlinedIcon,
    id: "rectangle",
    label: "Rectangle",
    shortcut: "2",
  },
  {
    Icon: CropSquareOutlinedIcon,
    iconClassName: "rotate-45 scale-90",
    id: "diamond",
    label: "Diamond",
    shortcut: "3",
  },
  {
    Icon: CircleOutlinedIcon,
    id: "ellipse",
    label: "Ellipse",
    shortcut: "4",
  },
  { Icon: CallMadeOutlinedIcon, id: "arrow", label: "Arrow", shortcut: "5" },
  { Icon: GestureOutlinedIcon, id: "draw", label: "Draw", shortcut: "7" },
  { Icon: TextFieldsOutlinedIcon, id: "text", label: "Text", shortcut: "8" },
  {
    Icon: AddPhotoAlternateOutlinedIcon,
    id: "image",
    label: "Image",
    shortcut: "9",
  },
]);

export const NATIVE_CANVAS_COMMANDS = Object.freeze({
  AI: {
    Icon: AutoAwesomeOutlinedIcon,
    id: "ai",
    label: "AI diagram assistant",
  },
  REDO: { Icon: RedoOutlinedIcon, id: "redo", label: "Redo", shortcut: "Shift+Cmd+Z" },
  STICKY: {
    Icon: LockOutlinedIcon,
    id: "sticky",
    label: "Keep selected tool active after drawing",
  },
  UNDO: { Icon: UndoOutlinedIcon, id: "undo", label: "Undo", shortcut: "Cmd+Z" },
  ZOOM_IN: { Icon: ZoomInOutlinedIcon, id: "zoom-in", label: "Zoom in" },
  ZOOM_OUT: { Icon: ZoomOutOutlinedIcon, id: "zoom-out", label: "Zoom out" },
});

/**
 * @param {{ label: string, shortcut?: string }} tool
 * @returns {string}
 */
export const getNativeCanvasToolTitle = ({ label, shortcut }) => {
  if (!shortcut) return label;

  return `${label} (${shortcut})`;
};
